<template>
  <div class="promo-page">
    <div class="hero-section">
      <div class="hero-bg"></div>
      <div class="hero-content">
        <div class="app-icon">
          <img src="../assets/img/logo-108x108.png" alt="记岁年" />
        </div>
        <h1 class="app-title">记岁年</h1>
        <p class="app-slogan">记录岁月，珍藏每一个重要时刻</p>
        <div class="hero-tags">
          <span class="tag">生辰提醒</span>
          <span class="tag">亲友关怀</span>
          <span class="tag">岁月记录</span>
        </div>
      </div>
      <div class="hero-wave">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,64 C360,120 720,0 1440,64 L1440,120 L0,120 Z" fill="#f5f5f5"/>
        </svg>
      </div>
    </div>
<!--    <div>-->
<!--      微信code： {{ wxCode }}-->
<!--    </div>-->
    <div class="invite-section">
      <div class="invite-card">
        <div class="invite-badge">知音专属</div>
        <h2 class="invite-title">🎁 知音邀请码</h2>
        <p class="invite-desc">你的好友为你准备了专属邀请码，下载APP后输入即可领取积分</p>
        <div class="invite-code-box" v-if="shareCode">
          <div class="code-deco-top"></div>
          <div class="code-inner">
            <span class="code-label">知音邀请码</span>
            <div class="code-value-wrap">
              <span class="code-value">{{ shareCode }}</span>
            </div>
            <div class="code-btns">
              <div class="code-copy-btn" @click="copyShareCode">
                <span v-if="copyTip === '已复制'">✅</span>
                <span v-else>📋</span>
                {{ copyTip }}
              </div>
              <div class="code-claim-btn" @click="claimReward" v-if="isInWeChat">
                <span>🎁</span>
                直接领取
              </div>
            </div>
          </div>
          <div class="code-deco-bottom"></div>
        </div>
        <div class="invite-code-box" v-else>
          <div class="code-inner">
            <div class="code-loading">
              <span class="loading-dot"></span>
              <span class="loading-dot"></span>
              <span class="loading-dot"></span>
            </div>
            <span class="code-label">邀请码加载中...</span>
          </div>
        </div>
        <div class="invite-steps">
          <div class="step" v-for="(step, idx) in steps" :key="idx">
            <span class="step-num">{{ idx + 1 }}</span>
            <span class="step-text">{{ step }}</span>
          </div>
          <div class="step-arrow" v-for="(item, idx) in steps.length - 1" :key="'a' + idx">→</div>
        </div>
      </div>
    </div>

    <div class="features-section">
      <div class="section-title">
        <span class="title-line"></span>
        <h2>为什么选择记岁年</h2>
        <span class="title-line"></span>
      </div>
      <div class="feature-grid">
        <div class="feature-item" v-for="(item, index) in features" :key="index">
          <div class="feature-icon" :style="{background: item.bg}">
            <span>{{ item.icon }}</span>
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <div class="download-section">
      <h2>立即下载记岁年</h2>
      <p>在应用市场搜索「记岁年」或点击下方按钮下载</p>
      <div class="download-btns">
        <div class="download-btn-item" v-for="store in visibleStores" :key="store.key" @click="openStore(store)">
          <span class="store-icon">{{ store.icon }}</span>
          <span>{{ store.name }}</span>
          <span class="store-tag" v-if="store.key === 'yingyongbao'">微信直达</span>
        </div>
      </div>
      <div class="guide-mask" v-if="showGuide" @click="showGuide = false">
        <div class="guide-content">
          <div class="guide-arrow"></div>
          <div class="guide-text">点击右上角 <strong>···</strong></div>
          <div class="guide-text">选择「在浏览器中打开」</div>
          <div class="guide-sub">即可跳转应用市场下载</div>
          <div class="guide-close">点击任意位置关闭</div>
        </div>
      </div>
    </div>

    <div class="footer-section">
      <p>© {{ new Date().getFullYear() }} 记岁年 · 北京六十甲子系统科学研究院</p>
    </div>

    <div class="float-cta" v-if="showFloat">
      <div class="float-cta-inner" @click="scrollToDownload">
        <span>📲</span> 立即下载记岁年APP
      </div>
    </div>

    <div class="claim-dialog" v-if="showClaimDialog" @click.self="showClaimDialog = false">
      <div class="claim-dialog-card">
        <div class="claim-dialog-icon">🎁</div>
        <h3 class="claim-dialog-title">领取积分奖励</h3>
        <p class="claim-dialog-desc">点击确认后将授权微信身份（openid），用于绑定你的账号并发放奖励积分。我们不会获取你的隐私信息。</p>
        <div class="claim-dialog-btns">
          <div class="claim-dialog-cancel" @click="showClaimDialog = false">取消</div>
          <div class="claim-dialog-confirm" :class="{ 'is-loading': claimLoading }" @click="confirmClaim">
            {{ claimLoading ? '领取中...' : '确认领取' }}
          </div>
        </div>
      </div>
    </div>

    <div class="success-dialog" v-if="showSuccessDialog" @click.self="showSuccessDialog = false">
      <div class="success-dialog-card">
        <div class="success-icon-wrap">
          <span class="success-check">✓</span>
        </div>
        <h3 class="success-title">领取成功！</h3>
        <p class="success-desc">积分奖励已发放到你的账户</p>
        <p class="success-hint">下载APP后使用微信登录，会自动发放奖励积分</p>
        <div class="success-btn" @click="showSuccessDialog = false">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'share',
  data () {
    return {
      shareCode: '',
      wxCode: '',
      copyTip: '点击复制',
      showFloat: false,
      showGuide: false,
      isInWeChat: false,
      showClaimDialog: false,
      showSuccessDialog: false,
      claimLoading: false,
      features: [
        { icon: '🎂', title: '生辰提醒', desc: '再也不错过亲友的生日，提前推送温馨提醒', bg: 'linear-gradient(135deg, #fff0ec, #ffe0d6)' },
        { icon: '📖', title: '岁月档案', desc: '记录每一个重要时刻，构建专属岁月档案', bg: 'linear-gradient(135deg, #fef3e2, #fde8c8)' },
        { icon: '👨‍👩‍👧‍👦', title: '亲友圈', desc: '与家人朋友共享美好时光，增进情感连接', bg: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)' },
        { icon: '🎁', title: '积分福利', desc: '邀请好友得积分，兑换专属礼品与特权', bg: 'linear-gradient(135deg, #e3f2fd, #bbdefb)' }
      ],
      allStores: [
        { key: 'huawei', name: '华为应用市场', icon: '📱', brand: 'huawei', scheme: 'appmarket://details?id=com.jisuinian.mobile', url: 'https://appgallery.huawei.com/app/detail?pkgName=com.jisuinian.mobile' },
        { key: 'honor', name: '荣耀应用市场', icon: '📱', brand: 'honor', scheme: 'appmarket://details?id=com.jisuinian.mobile', url: 'https://appgallery.honor.com/app/detail?pkgName=com.jisuinian.mobile' },
        { key: 'xiaomi', name: '小米应用商店', icon: '📱', brand: 'xiaomi', scheme: 'market://details?id=com.jisuinian.mobile', url: 'https://app.mi.com/details?id=com.jisuinian.mobile' },
        { key: 'oppo', name: 'OPPO软件商店', icon: '📱', brand: 'oppo', scheme: 'market://details?id=com.jisuinian.mobile', url: 'https://store.oppomobile.com/product/123456' },
        { key: 'vivo', name: 'vivo应用商店', icon: '📱', brand: 'vivo', scheme: 'market://details?id=com.jisuinian.mobile', url: 'https://h5.app.vivo.com.cn/detail/com.jisuinian.mobile' },
        { key: 'yingyongbao', name: '应用宝', icon: '⭐', brand: 'all', scheme: '', url: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.jisuinian.mobile' }
      ],
      steps: [
        '复制邀请码',
        '下载记岁年APP',
        '输入邀请码领积分'
      ]
    }
  },
  computed: {
    visibleStores () {
      if (this.isInWeChat) {
        return this.allStores
      }
      let brand = this.detectBrand()
      return this.allStores.filter(s => s.brand === brand || s.brand === 'all')
    }
  },
  methods: {
    isWeChat () {
      let ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    detectBrand () {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('huawei') !== -1 || ua.indexOf('honor') !== -1) return 'huawei'
      if (ua.indexOf('xiaomi') !== -1 || ua.indexOf('mi ') !== -1) return 'xiaomi'
      if (ua.indexOf('oppo') !== -1 || ua.indexOf('realme') !== -1 || ua.indexOf('oneplus') !== -1) return 'oppo'
      if (ua.indexOf('vivo') !== -1) return 'vivo'
      return 'unknown'
    },
    getWeChatOpenId () {
      this.claimLoading = true
      let _this = this
      fetch(this.$httpConf.baseURL + '/login/getOpenIdEndRegister', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ wxCode: _this.wxCode, shareCode: _this.shareCode })
      })
        .then(function (res) { return res.json() })
        .then(function (res) {
          _this.claimLoading = false
          if (res.status === 200) {
            _this.showSuccessDialog = true
          } else {
            _this.$message.error(res.msg || '领取失败，请稍后重试')
          }
        })
        .catch(function () {
          _this.claimLoading = false
          _this.$message.error('网络异常，请稍后重试')
        })
    },
    claimReward () {
      this.showClaimDialog = true
    },
    confirmClaim () {
      this.showClaimDialog = false
      let redirectUri = encodeURIComponent('https://jisuinian.com/share' + '?shareCode=' + this.shareCode)
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + 'wxf7a895359d26d679' +
        '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      window.location.href = url
    },
    copyShareCode () {
      if (!this.shareCode) return
      let _this = this
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.shareCode).then(function () {
          _this.copyTip = '已复制'
          setTimeout(function () { _this.copyTip = '点击复制' }, 2000)
        })
      } else {
        let input = document.createElement('input')
        input.value = this.shareCode
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        _this.copyTip = '已复制'
        setTimeout(function () { _this.copyTip = '点击复制' }, 2000)
      }
    },
    scrollToDownload () {
      let el = document.querySelector('.download-section')
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
    openStore (store) {
      if (store.key === 'yingyongbao') {
        window.location.href = store.url
        return
      }
      if (this.isInWeChat) {
        this.showGuide = true
        return
      }
      try {
        window.location.href = store.scheme
        setTimeout(function () {
          window.location.href = store.url
        }, 1500)
      } catch (e) {
        window.open(store.url, '_blank')
      }
    },
    handleScroll () {
      this.showFloat = window.scrollY > 400
    }
  },
  mounted () {
    document.title = '记岁年 - 记录岁月，珍藏时光'
    let shareCode = this.$route.params.shareCode || this.$route.query.shareCode
    this.shareCode = shareCode
    this.isInWeChat = this.isWeChat()
    if (this.isInWeChat) {
      if (this.$route.query.code) {
        this.wxCode = this.$route.query.code
        this.getWeChatOpenId()
      }
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.promo-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  color: #333;
  background: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 80px;
}

.hero-section {
  position: relative;
  background: linear-gradient(135deg, #9e0c0c, #c0392b, #e74c3c);
  padding: 60px 20px 80px;
  text-align: center;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 60%);
  animation: heroPulse 6s ease-in-out infinite;
}

@keyframes heroPulse {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.8; }
}

.hero-content {
  position: relative;
  z-index: 1;
}

.app-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border: 1px solid #f2f2f2;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  background: #fff;
}

.app-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.app-title {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
  letter-spacing: 4px;
}

.app-slogan {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 20px;
}

.hero-tags {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.tag {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 4px 14px;
  border-radius: 50px;
  font-size: 13px;
  backdrop-filter: blur(4px);
}

.hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  line-height: 0;
}

.hero-wave svg {
  width: 100%;
  height: 40px;
  display: block;
}

.invite-section {
  padding: 30px 20px;
  background: #f5f5f5;
}

.invite-card {
  background: linear-gradient(135deg, #fff5f5, #fff0ec);
  border-radius: 20px;
  padding: 30px 20px;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(192, 57, 43, 0.1);
  border: 1px solid rgba(192, 57, 43, 0.08);
}

.invite-badge {
  position: absolute;
  top: 16px;
  right: -28px;
  background: linear-gradient(135deg, #ff6b6b, #c0392b);
  color: #fff;
  font-size: 11px;
  padding: 4px 36px;
  transform: rotate(45deg);
  font-weight: 600;
}

.invite-title {
  font-size: 20px;
  font-weight: 700;
  color: #9e0c0c;
  text-align: center;
  margin: 0 0 8px;
}

.invite-desc {
  font-size: 13px;
  color: #888;
  text-align: center;
  margin: 0 0 24px;
}

.invite-code-box {
  margin-bottom: 24px;
}

.code-deco-top,
.code-deco-bottom {
  height: 6px;
  background: repeating-linear-gradient(
    90deg,
    #c0392b 0px,
    #c0392b 8px,
    transparent 8px,
    transparent 16px
  );
  opacity: 0.15;
  border-radius: 3px;
}

.code-inner {
  background: #fff;
  border-left: 4px solid #c0392b;
  border-right: 4px solid #c0392b;
  border-radius: 12px;
  padding: 24px 20px;
  text-align: center;
  position: relative;
}

.code-inner::before,
.code-inner::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background: #fff0ec;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
}

.code-inner::before {
  left: -14px;
}

.code-inner::after {
  right: -14px;
}

.code-label {
  display: block;
  font-size: 12px;
  color: #999;
  margin-bottom: 10px;
  letter-spacing: 2px;
}

.code-value-wrap {
  margin-bottom: 16px;
}

.code-value {
  font-size: 30px;
  font-weight: 700;
  color: #9e0c0c;
  letter-spacing: 4px;
  font-family: 'Courier New', monospace;
  user-select: all;
}

.code-btns {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.code-copy-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #9e0c0c, #c0392b);
  color: #fff;
  padding: 10px 28px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.3);
}

.code-claim-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #ff6b6b, #e74c3c);
  color: #fff;
  padding: 10px 28px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
}

.code-claim-btn:active {
  transform: scale(0.95);
  box-shadow: 0 2px 6px rgba(231, 76, 60, 0.2);
}

.code-loading {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-bottom: 10px;
}

.loading-dot {
  width: 8px;
  height: 8px;
  background: #c0392b;
  border-radius: 50%;
  animation: dotBounce 1.4s ease-in-out infinite;
}

.loading-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
}

.invite-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.step {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.7);
  padding: 8px 14px;
  border-radius: 50px;
  font-size: 12px;
  color: #666;
}

.step-num {
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #9e0c0c, #c0392b);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.step-arrow {
  color: #ccc;
  font-size: 14px;
  font-weight: 700;
}

.features-section {
  padding: 40px 20px;
  background: #fff;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 30px;
}

.section-title h2 {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
}

.title-line {
  display: inline-block;
  width: 40px;
  height: 2px;
  background: linear-gradient(to right, transparent, #c0392b);
}

.title-line:last-child {
  background: linear-gradient(to left, transparent, #c0392b);
}

.feature-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 500px;
  margin: 0 auto;
}

.feature-item {
  background: #fafafa;
  border-radius: 16px;
  padding: 24px 16px;
  text-align: center;
  transition: transform 0.3s ease;
}

.feature-item:active {
  transform: scale(0.97);
}

.feature-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 28px;
}

.feature-item h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 6px;
  color: #333;
}

.feature-item p {
  font-size: 12px;
  color: #888;
  line-height: 1.6;
  margin: 0;
}

.download-section {
  padding: 40px 20px;
  background: #fff;
  text-align: center;
  margin-top: 1px;
}

.download-section h2 {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px;
}

.download-section p {
  font-size: 13px;
  color: #888;
  margin: 0 0 24px;
}

.download-btns {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  max-width: 500px;
  margin: 0 auto;
}

.download-btn-item {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 12px 18px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
}

.download-btn-item:active {
  background: #fff0ec;
  border-color: #c0392b;
  color: #9e0c0c;
}

.store-icon {
  font-size: 18px;
}

.footer-section {
  text-align: center;
  padding: 30px 20px;
  font-size: 12px;
  color: #bbb;
}

.float-cta {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  padding: 20px 16px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  z-index: 999;
  backdrop-filter: blur(10px);
}

.float-cta-inner {
  background: linear-gradient(135deg, #9e0c0c, #c0392b);
  color: #fff;
  text-align: center;
  padding: 14px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.float-cta-inner:active {
  opacity: 0.85;
}

.claim-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.claim-dialog-card {
  background: #fff;
  border-radius: 20px;
  padding: 36px 28px 28px;
  max-width: 360px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  animation: dialogIn 0.3s ease;
}

@keyframes dialogIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.claim-dialog-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.claim-dialog-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 12px;
}

.claim-dialog-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 24px;
}

.claim-dialog-btns {
  display: flex;
  gap: 12px;
}

.claim-dialog-cancel {
  flex: 1;
  padding: 12px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  color: #666;
  background: #f5f5f5;
  cursor: pointer;
  transition: all 0.2s;
}

.claim-dialog-cancel:active {
  background: #e8e8e8;
}

.claim-dialog-confirm {
  flex: 1;
  padding: 12px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #9e0c0c, #c0392b);
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.3);
}

.claim-dialog-confirm:active {
  transform: scale(0.96);
}

.claim-dialog-confirm.is-loading {
  opacity: 0.7;
  pointer-events: none;
}

.success-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.success-dialog-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px 28px 28px;
  max-width: 360px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  animation: dialogIn 0.3s ease;
}

.success-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #52c41a, #73d13d);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 4px 16px rgba(82, 196, 26, 0.3);
}

.success-check {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
}

.success-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px;
}

.success-desc {
  font-size: 15px;
  color: #666;
  margin: 0 0 16px;
}

.success-hint {
  font-size: 13px;
  color: #999;
  margin: 0 0 24px;
  line-height: 1.6;
}

.success-hint strong {
  color: #9e0c0c;
  font-size: 15px;
  letter-spacing: 2px;
}

.success-btn {
  background: linear-gradient(135deg, #9e0c0c, #c0392b);
  color: #fff;
  padding: 12px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.3);
}

.success-btn:active {
  transform: scale(0.96);
}
</style>



// WEBPACK FOOTER //
// src/components/Share.vue